(function () {
    'use strict';
    $(document).ready(function () {

        whatInput.ask();

        $(".top-index-label").on('click', function(){
            $(this).siblings('.top-index-list').slideToggle();
            $(this).parent().toggleClass('open');
            toggleAriaExpanded($(this));
        });

        $(".top-index-list li").on('click', function(){
            $(this).parent().slideUp();
            $(this).parent().parent().removeClass('open');
            toggleAriaExpanded($(this).parent().parent().find('button'));
        });

        function toggleAriaExpanded(elem) {
            var expanded = elem.attr('aria-expanded');
            if (expanded === 'false')
                elem.attr('aria-expanded', 'true');
            else
                elem.attr('aria-expanded', 'false');
        }

        // SOCIAL SHARING
        const $share = $('#share');
        $share.jsSocials({
            showLabel: false,
            showCount: false,
            shareIn: "popup",
            text: document.title,
            url: window.location.href,
            shares: [
                {
                    share: "facebook",
                    logo: `${$share.attr('data-templateURL')}/dist/images/facebook.svg`,
                    inlineSvg: true,
                },
                {
                    share: "linkedin",
                    logo: `${$share.attr('data-templateURL')}/dist/images/linkedin.svg`,
                    inlineSvg: true,
                },
                {
                    share: "twitter",
                    logo: `${$share.attr('data-templateURL')}/dist/images/twitter.svg`,
                    inlineSvg: true,
                    via: "santanderbankpl",
                }
            ]
        });

        $('.jssocials-share').each(function(item) {
            var liClasses = $(this).attr('class').split(/[\s-]+/);
            var socialPage = liClasses[liClasses.length-1];
            $(this).find('.jssocials-share-link').append('<span class="sr-only">Udostępnij w serwisie: <span lang="en">' + socialPage + '</span></span>');
        });

        //tools show/hide
        $('#tools-toggle').click(function () {
            $('.tools-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
            toggleAriaExpanded($(this));
        });

        //side menu show/hide
        $('#side-toggle').click(function () {
            $('.side-list').animate({
                height: 'toggle'
            });
            $(this).toggleClass('opened');
            toggleAriaExpanded($(this));
        });

        // accordion scroll animation
        $('.subpage .accordion.scroll-animation .collapse, .subpage .accordion .collapse').on('shown.bs.collapse', function (e) {
            updateTableSize();
            var positionTop = $(this).parent().offset().top; // - $('header').height();
            $('html, body').animate({
                scrollTop: positionTop
            }, 500);
            $(window).resize();
        });

        // responsive image enlarging
        $('.popup-trigger').click(function (e) {
            $(this).parent().find('.popup-image-container').fadeIn();
            e.preventDefault();
            return false;
        });

        $('.popup-image-container').click(function () {
            $(this).fadeOut();
        });

        //Tooltipster

        // default tooltips
        $('.default-tooltipster').tooltipster({
            maxWidth: 290,
            contentAsHTML: true,
            interactive: true,
            functionPosition: function (instance, helper, position) {
                position.coord.left = helper.geo.origin.offset.left - 20;
                return position;
            },
            trigger: 'custom',
            triggerOpen: {
                mouseenter: true,
                touchstart: true
            },
            triggerClose: {
                click: true,
                scroll: true,
                tap: true,
                mouseleave: true
            },
            functionInit: function (instance, helper) {
                var content = $(instance._$origin).next().html();
                instance.content(content);
            },
            functionReady: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', false);
            },
            functionAfter: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', true);
            }

        });

        $('.tooltipster.dictionary-word').tooltipster({
            maxWidth: 275,
            theme: 'dictionary-theme',
            contentAsHTML: true,
            trigger: 'custom',
            triggerOpen: {
                mouseenter: true,
                touchstart: true
            },
            triggerClose: {
                click: true,
                scroll: true,
                tap: true,
                mouseleave: true
            },
            functionInit: function (instance, helper) {
                var content = $(instance._$origin).next().html();
                instance.content(content);
            },
            functionPosition: function (instance, helper, position) {
                position.coord.top += 10;
                position.coord.left = helper.geo.origin.offset.left;
                return position;
            },
            functionReady: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', false);
            },
            functionAfter: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', true);
            }
        });
        $('.tooltipster.dictionary-word')
        .focus(function () {
            $(this).tooltipster('open');
        })
        .blur(function () {
            $(this).tooltipster('close');
        });

        $(document).keyup(function(e) {
            if (e.keyCode == 27) {
                $('.default-tooltipster').tooltipster('close');
            }
        });

        $('.default-tooltipster').tooltipster({
            theme: 'gri-theme',
            maxWidth: 250,
            interactive: true,
            contentAsHTML: true,
            trigger: 'custom',
            triggerOpen: {
                mouseenter: true,
                touchstart: true
            },
            triggerClose: {
                click: true,
                scroll: true,
                tap: true,
                mouseleave: true
            },
            functionInit: function (instance, helper) {
                var content = $(instance._$origin).next().html();
                instance.content(content);
            },
            functionPosition: function (instance, helper, position) {
                if ($(window).width() > 768) {
                    position.coord.top += 5;
                    position.coord.left = helper.geo.origin.offset.left;
                }
                return position;
            },
            functionReady: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', false);
            },
            functionAfter: function (instance, helper) {
                $(instance._$origin).next().attr('aria-hidden', true);
            }
        });
        $('.default-tooltipster')
        .focus(function () {
            $(this).tooltipster('open');
        })
        .blur(function () {
            $(this).tooltipster('close');
        });

        function updateTableSize() {
            $('.table-container').each(function () {
                var containerWidth = $(this).width();
                var tableWidth = $('table', this).width();

                if ($('table', this).hasClass('freeze-header') && $(window).width() > 768) {
                    return
                }
                if ($(this).hasClass('prevent-scrollable')) {
                    if (!$(this).parent().hasClass('card-body')) {
                        return;
                    }
                }

                if (tableWidth > containerWidth) {
                    $(this).addClass('scrollable');
                    $(this).mCustomScrollbar({
                        axis: "x",
                        mouseWheel: {
                            enable: true
                        }
                    });
                } else {
                    $(this).removeClass('scrollable');
                    $(this).mCustomScrollbar('destroy');
                }
            });
        }

    });
}(jQuery));
